import { evaluateExpression } from './expressionEvaluator'

export const availableFilters = ["strike"]

// map for maintaining whether filter prefers referenced security whenever available
export const filterDerivedUsageMap: Record<string, boolean> = {
    strike: true
}

/**
 * Drop-in for the previous mathjs instance: the app only ever called `math.evaluate(expr, scope)`
 * with the restricted expression grammar, so a purpose-built evaluator replaces the 1.7 MB library.
 */
const math = {
    evaluate: (expression: string, scope: Record<string, unknown> = {}): number => evaluateExpression(expression, scope)
}

export default math
